import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import { getContext as _getContext } from '../../common/utils/utils';
var RequestMaker = /*#__PURE__*/function () {
  function RequestMaker(endpoint) {
    _classCallCheck(this, RequestMaker);
    this.endpoint = endpoint;
  }
  _createClass(RequestMaker, [{
    key: "getHeaders",
    value: function getHeaders() {
      var headers = new Headers();
      headers.append('Content-Type', 'application/json');
      return headers;
    }
  }, {
    key: "getContext",
    value: function getContext(contextResolver) {
      return _getContext(contextResolver);
    }
  }]);
  return RequestMaker;
}();
export { RequestMaker as default };